var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniqueView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 52H2V37.4839",
    stroke: "#594AD7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 2H2V16.5161",
    stroke: "#594AD7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 52H54V37.4839",
    stroke: "#594AD7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 2H54V16.5161",
    stroke: "#594AD7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2406_588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8436 26.6884C44.6429 26.1842 39.7763 14.375 27.4995 14.375C15.2227 14.375 10.356 26.1842 10.1553 26.6884C9.94806 27.2096 9.94806 27.7909 10.1553 28.3121C10.356 28.8158 15.2227 40.625 27.4995 40.625C39.7763 40.625 44.6429 28.8158 44.8436 28.3116C45.0509 27.7904 45.0509 27.2096 44.8436 26.6884ZM27.4995 31.875C25.0834 31.875 23.1245 29.9161 23.1245 27.5C23.1245 25.0839 25.0834 23.125 27.4995 23.125C29.9156 23.125 31.8745 25.0839 31.8745 27.5C31.8745 29.9161 29.9156 31.875 27.4995 31.875Z",
    fill: "#F22B5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2406_588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueView);
export default __webpack_public_path__ + "static/media/unique_view.e4731200d3d5b1ccf0ce8a2cca2265e8.svg";
export { ForwardRef as ReactComponent };